class RecipePrint extends HTMLElement {
  constructor() {
    super();

    this.toggles = this.querySelectorAll('input[name="print_options"]');
    this.printButton = this.querySelector('[data-print-trigger]');
  }

  connectedCallback() {
    this.toggles.forEach(toggle => {
      this.applyToggle(toggle);
      toggle.addEventListener('change', this.onToggleChange.bind(this));
    });

    if (this.printButton) {
      this.printButton.addEventListener('click', this.onPrint.bind(this));
    }
  }

  onToggleChange(event) {
    this.applyToggle(event.currentTarget);
  }

  applyToggle(toggle) {
    const sectionName = toggle.value;
    const isVisible = toggle.checked;
    const targets = this.querySelectorAll(`[data-section="${sectionName}"]`);

    targets.forEach(target => {
      target.hidden = !isVisible;
      target.setAttribute('aria-hidden', String(!isVisible));
    });

    toggle.setAttribute('aria-expanded', String(isVisible));
  }

  onPrint() {
    window.print();
  }
}

if (!customElements.get('recipe-print')) {
  customElements.define('recipe-print', RecipePrint);
}
